"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postSubcontactorUser = void 0;
/**
 * Allows you to register a new user account for the Clearabee subcontractor app
 */
var postSubcontactorUser = function (instance) {
    return function (body, config) {
        return instance.post("/users/subcontractor", body, config);
    };
};
exports.postSubcontactorUser = postSubcontactorUser;
